// Calendar-date helpers shared by the Calendar and Targets pages. Dates are UTC-midnight Date
// objects standing for UK calendar days (keys like "2026-10-02", from ukDateKey).
import { ukDateKey } from './format.js'

export const dateKey = (d) => d.toISOString().slice(0, 10)
export const utcDate = (key) => new Date(`${key}T00:00:00Z`)
export const addDays = (d, n) => { const x = new Date(d); x.setUTCDate(x.getUTCDate() + n); return x }
export const todayKey = () => ukDateKey(new Date().toISOString())

// Month m is 0-based, as in Date.
export const daysInMonth = (y, m) => new Date(Date.UTC(y, m + 1, 0)).getUTCDate()
export const daysInYear = (y) => (daysInMonth(y, 1) === 29 ? 366 : 365)
// 1 for 1 January.
export const dayOfYear = (d) => Math.round((d - Date.UTC(d.getUTCFullYear(), 0, 1)) / 86400000) + 1
